const toNumber = <T extends string>(value: T) => value.replace(/[^\d]/g, '');

export default toNumber;
